import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Button, Text } from 'components/chroma';
import { MarketingCampaignBannerContentProps } from '../types';

const MarketingTextWrapper = styled.div`
  p {
    margin: 0;
  }
`;

export const MarketingCampaignBannerContent: FunctionComponent<MarketingCampaignBannerContentProps> = ({
  text,
  subText,
  onClick,
  exclusions,
  termsLinkText,
  shouldShowHeaderText = true,
}) => (
  <>
    <MarketingTextWrapper>
      {shouldShowHeaderText && <Text margin={{ bottom: 0 }}>{text ?? ''}</Text>}
      <Text margin={{ bottom: 0 }}>
        {!shouldShowHeaderText ? (
          <strong>{subText ?? ''}</strong>
        ) : (
          subText || ''
        )}
      </Text>
    </MarketingTextWrapper>
    <Button link margin={{ top: 0 }} onClick={onClick}>
      {exclusions && <>Exclusions and </>}
      {termsLinkText}
    </Button>
  </>
);

export default MarketingCampaignBannerContent;
